import { useEffect, useMemo, useState } from "react";
import resolution, { SizeEnum } from "./config";
import ResolutionBox from "./ResolutionBox/ResolutionBox";
import "./Resolution.less";

interface IResolution {
  onChange?: (e) => void;
  value?: string;
  type?: number;
}

const Resolution: React.FC<IResolution> = (props) => {
  const { onChange, value, type } = props;
  const options = useMemo(() => {
    return type === 3 ? resolution.slice(0, 3) : resolution
  }, [type])
  const [activeindex, setActiveIndex] = useState(1000);
  const toValueGetIndex = (name: string) => {
    const index = options.findIndex((item) => item.name === name);
    return index > -1 ? index : 1000;
  };

  useEffect(() => {
    setActiveIndex(toValueGetIndex(value));
  }, [value]);
  return (
    <>
      <ul className="resolution-wrapper">
        {options.map((item, index) => {
          return (
            <li
              key={item.name + index}
              onClick={() => {
                setActiveIndex(index);
                if (onChange) {
                  onChange(item.name);
                }
              }}
              className={`${activeindex === index ? "active" : ""}`}>
              {item.name !== "customized" ? (
                <ResolutionBox size={item.title as SizeEnum} />
              ) : (
                <></>
              )}
              {item.title}
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default Resolution;
